// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all language JSON files
import en from './locales/en-us.json';
import zhCN from './locales/zh-cn.json';
import zhTW from './locales/zh-tw.json';
import frCA from './locales/fr-ca.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import arSA from './locales/ar-sa.json';
import nl from './locales/nl.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ptBR from './locales/pt-br.json';
import ru from './locales/ru.json';
import th from './locales/th.json';
import vi from './locales/vi.json';
import it from './locales/it.json';
import pl from './locales/pl.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-us': { translation: en },
      'zh-cn': { translation: zhCN },
      'zh-tw': { translation: zhTW },
      'fr-ca': { translation: frCA },
      es: { translation: es },
      pt: { translation: pt },
      'ar-sa': { translation: arSA },
      nl: { translation: nl },
      fr: { translation: fr },
      de: { translation: de },
      ja: { translation: ja },
      ko: { translation: ko },
      'pt-br': { translation: ptBR },
      ru: { translation: ru },
      th: { translation: th },
      vi: { translation: vi },
      it: { translation: it },
      pl: { translation: pl },
    },
    fallbackLng: 'en-us',
    detection: {
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    },
    lowerCaseLng: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
